import React from 'react';
import CONFIG from '../../../Config';

/**
 *  buttons: {
 *    0: "Option 0",
 *    1: "Option 1",  
 *  }
 *  payloads: {...buttons},
 *  buttonsData: {
 *    dual_buttons: true,
 *    icons: {0: "none", 1: "none"},
 *    images: {0: "", 1: ""},
 *    includes: {0: "none", 1: "none"},
 *    multi: false,
 *    pile_up: false
 *  }
 */
class InputMenu extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      buttons: props.buttons,
      payloads: props.payloads,
      buttonsData: props.buttonsData,
      buttonSubmitHandler: props.buttonSubmitHandler,
      search_filter: '',
      filter_results: props.buttons instanceof Array ? 
        props.buttons.map(b => b.toLowerCase()) :
        Object.keys(props.buttons).map(b => props.buttons[b].toLowerCase()),
    };
    this.buttonsContainer = null;
  }

  shouldComponentUpdate(nextProps, nextState) {
    const { buttons, payloads, buttonsData } = this.props;
    if (
      !this.compareObjects(buttons, nextProps.buttons) ||
      !this.compareObjects(payloads, nextProps.payloads) ||
      !this.compareObjects(buttonsData, nextProps.buttonsData)
    )
      return true;
    const { search_filter, filter_results } = this.state;
    if (
      search_filter !== nextState.search_filter ||
      !this.compareObjects(filter_results, nextState.filter_results)
    )
      return true;
    return false;
  }

  compareObjects(a, b) {
    return JSON.stringify(a) === JSON.stringify(b);
  }

  clickHandler(index) {
    const { buttons, payloads } = this.props;
    const _buttons = buttons instanceof Array ? 
      buttons :
      Object.keys(buttons).map(b => buttons[b]);
    let _payloads = null;
    if (payloads)
      _payloads = payloads instanceof Array ? 
        payloads :
        Object.keys(payloads).map(b => payloads[b]);
    else
      _payloads = buttons instanceof Array ? 
        buttons :
        Object.keys(buttons).map(b => buttons[b]);
    this.props.buttonSubmitHandler(
      _buttons[index],
      _payloads[index],
    );
    const btn = this.buttonsContainer
      .querySelector(`.menu-button[data-key="${index}"]`);
    btn.className += ' clicked';
    btn.blur();
  }

  onSearchInput(e) {
    this.setState({
      search_filter: e.target.value,
      filter_results: this.getMatches(e.target.value),
    });
  }

  getMatches(value) {
    const { buttons } = this.props;
    const _buttons = buttons instanceof Array ? 
      buttons.map(b => b.toLowerCase()) :
      Object.keys(buttons).map(b => buttons[b].toLowerCase());
    const matches = _buttons
      .filter((b) => b.indexOf(value.toLowerCase()) > -1);
    return matches;
  }

  mountIncludes(key) {
    const { includes, icons, images } = this.props.buttonsData;
    if (includes)
      switch (includes[key]) {
        case 'icon':
          if (icons)
            return (
              <div className="include-icon-container">
                <i className={`fi ${icons[key]}`}></i>
              </div>
            );
          else
            return null;
        case 'image':
          if (images)
            return (
              <div className="include-image-container">
                <div
                  className="include-image" 
                  style={`background-image: url(${images[key]})`}
                ></div>
              </div>
            );
          else
            return null;
        default:
          return null;
      }
  }

  render() {
    const { buttons, buttonsData } = this.props;
    const { clicked, search_filter, filter_results } = this.state;
    const { dual, pile_up, search } = buttonsData;
    const _buttons = buttons instanceof Array ? 
      buttons :
      Object.keys(buttons).map(b => buttons[b]);
    const extra_classes = () => {
      let classes = '';
      if (buttonsData.dual_buttons)
        classes = classes.concat(' dual');
      if (buttonsData.pile_up)
        classes = classes.concat(' pileup');
      return classes;
    }

    if (!search)
      return (
        <div className="hu-input-menu">
          <span className="hu-input-menu-info not-selectable hu-s-10 hu-color_contrast hu-t-uppercase">{ CONFIG.text.input_menu_help }</span>
          <div 
            className={`hu-input-menu-buttons${extra_classes()}`}
            ref={(elem) => {this.buttonsContainer = elem;}}
          >
            { _buttons.map((key, index) => 
              <button
                key={Math.random()} // A different key forces update button and delete 'clicked' class
                onClick={() => {this.clickHandler(index);}}
                className={`menu-button ${buttonsData.includes ? buttonsData.includes[index] : ''} hu-color_button-text hu-background-color_button-background hu-border-color_button-background-dark`}
                data-key={index}
                tabIndex={index + 1}
              >
                {this.mountIncludes(index)}
                <span className="button-text">{key}</span>
              </button> 
            )}
          </div>
        </div>
      );
    else
      return (
        <div className="hu-input-menu">
          <span className="hu-input-menu-info not-selectable hu-s-10 hu-color_contrast hu-t-uppercase">{ CONFIG.text.input_instant_search_help }</span>
          <div className="hu-drop-search">
            <div className="drop-search-input-container">
              <input 
                className="drop-search-input hu-color_contrast hu-s-14" 
                type="text"
                placeholder={CONFIG.text.search}
                value={search_filter}
                onInput={(e) => this.onSearchInput(e)}
              />
              <i className="fi magnification-lens hu-color_contrast"></i>
            </div>
            <div 
              className={`hu-input-menu-buttons${extra_classes()}`}
              ref={(elem) => {this.buttonsContainer = elem;}}
            >
              { _buttons.map((key, index) => {
                return ( filter_results.indexOf(key.toLowerCase()) > -1 &&
                  <button
                    key={Math.random()} // A different key forces update button and delete 'clicked' class
                    onClick={() => {this.clickHandler(index)}}
                    className={`menu-button ${buttonsData.includes ? buttonsData.includes[index] : ''} hu-color_button-text hu-background-color_button-background hu-border-color_button-background-dark`}
                    data-key={index}
                    tabIndex={index + 1}
                  >
                    {this.mountIncludes(index)}
                    <span className="button-text">{key}</span>
                  </button> 
                );
              })}
            </div>
          </div>
        </div>
      );
  }
}

export default InputMenu;


// WEBPACK FOOTER //
// ./app/js/components/messenger/input/InputMenu.js